export const BulkFulfillmentPlanTypeEnum = {
  Mixed: 'Mixed',
  International: 'International',
  Domestic: 'Domestic',
};
